import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from 'react-router-dom';
import { Colors } from '../../common/Colors';
import { ListProps, ItemButtonProps, AlignType } from './index';
import { Svg } from '../../common/IconSvg/styles';
import { helperListItemHover, helperButtonReset } from '../../helpers';
import { exceptStyledProps, getRem } from '../../utils';

export const icon = css`
  align-self: center;
  flex-shrink: 0;
  margin-right: 2rem;
`;

interface ItemInnerProps {
  align?: AlignType;
}

export const ItemInner = styled('div')<ItemInnerProps>`
  position: relative;
  display: block;
  display: flex;
  align-items: ${props => props.align};
  padding: 1.5rem 3rem 1.5rem 4rem;
  font-size: 1.4rem;
  line-height: 1.2;

  & > ${Svg} {
    &:first-of-type {
      ${icon};
    }
  }
`;

export const List = styled('div')<ListProps>`
  overflow: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  flex-grow: 1;
  max-height: ${props => getRem(props.height)};

  ${ItemInner} {
    padding: ${props => props.paddingItems};
  }
`;

export const Item = styled('div')`
  margin: 0;
`;

const inlineMiddle = css`
  display: inline-block;
  vertical-align: middle;
`;

export const Icon = styled('span')`
  ${inlineMiddle};
  ${icon};

  img,
  svg {
    vertical-align: middle;
    max-width: 2rem;
    height: auto;
  }
`;

export const Name = styled('div')`
  ${inlineMiddle};
  flex-grow: 1;
  min-width: 0;
  padding-top: 0.1rem;
  word-wrap: break-word;
`;

export const Caption = styled('div')`
  ${inlineMiddle};
  flex-shrink: 0;
  padding-top: 0.1rem;
  margin-left: 0.8rem;
  text-transform: uppercase;
  font-size: 1.2rem;
  letter-spacing: 0.076em;
  color: ${Colors.rgbaBlack50};
`;

export const IconSecond = styled('div')`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 100%;
  width: 2.4rem;
  height: 2.4rem;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 0.5rem;
  margin-left: -3.6rem;
  line-height: 1;
`;

export const ItemButton = styled('button', exceptStyledProps())<ItemButtonProps>`
  cursor: ${props => props.isActive && 'default'};
  display: block;
  width: 100%;
  text-align: left;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  text-decoration: none;

  ${props => !props.as && helperButtonReset};

  ${props =>
    !props.isDisabled &&
    (!props.as || props.as === Link || props.as === 'a') &&
    helperListItemHover({
      isActive: props.isActive
    })};

  ${props =>
    props.isDisabled &&
    css`
      cursor: not-allowed;

      ${Name},
      ${Name} *,
      ${Caption},
      ${Caption} * {
        color: ${Colors.rgbaBlack30} !important;
      }

      ${ItemInner} > ${Svg},
      ${ItemInner} > ${Icon} {
        opacity: 0.3;
      }

      ${ItemInner} > ${Icon} {
        ${Svg} {
          opacity: 1;
        }
      }
    `}
`;
